import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

export default function Barcode({ value, height = 50, displayValue = true, fontSize = 12 }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && value) {
      try {
        JsBarcode(ref.current, value, {
          format: "CODE128",
          width: 1.6,
          height,
          displayValue,
          fontOptions: "bold",
          font: "JetBrains Mono",
          fontSize,
          margin: 4,
        });
      } catch (e) {
        console.warn("Barcode render failed", e);
      }
    }
  }, [value, height, displayValue, fontSize]);
  return <svg ref={ref} data-testid={`barcode-${value}`} />;
}
